import React, { ReactNode } from "react";
import { Flex, FlexProps } from "@chakra-ui/react";

interface Props extends FlexProps {
  children?: ReactNode;
}

function FeatureSectionContainer({ children, ...props }: Props) {
  return (
    <Flex
      paddingY={{
        base: "60px",
        lg: "120px",
        xl: "120px",
      }}
      flexDirection={{
        base: "column",
        md: "row",
      }}
      gap={{
        base: "32px",
        lg: "60px",
      }}
      alignItems={"center"}
      {...props}
    >
      {children}
    </Flex>
  );
}

export default FeatureSectionContainer;
